import { Statement } from './datagram';
import { Guà, Identity, hexagrams } from './hexagram';

enum Sequence {
  EarlierHeaven = 'Earlier heaven', // Fu Xi, Xiantiantu
  LaterHeaven = 'Later heaven', // King Wen, Houtiantu
  BinaryAscending = 'Binary ascending', // Shao Yong square
  BinaryDescending = 'Binary descending' // Shao Yong square descending
}

export type SequenceTransform = (lines: Statement) => number;

export const setting: string = 'Sequence';

export const sequences = Object.keys(Sequence);

export const label = (value: string) =>
  Sequence[value as keyof typeof Sequence];
// TODO: i18n

export const icon = (value: string) => {
  switch (value) {
    case sequences[3]:
      return 'sort-bool-ascending-variant';
    case sequences[2]:
      return 'sort-bool-descending-variant';
    case sequences[1]:
      return 'sort-bool-ascending';
    case sequences[0]:
    default:
      return 'sort-bool-descending';
  }
};

export const chosen = (value: number | undefined, sequence?: string) => {
  if (sequence && (sequence === sequences[1] || sequence === sequences[3])) {
    if (value === 8) return 7;
    if (value === 7) return undefined;

    return 8;
  }

  if (value === 7) return 8;
  if (value === 8) return undefined;

  return 7;
};

export const next = (value: string) => {
  // @todo poor-man rotation
  switch (value) {
    case sequences[0]:
      return sequences[1];
    case sequences[1]:
      return sequences[2];
    case sequences[2]:
      return sequences[3];
    case sequences[3]:
    default:
      return sequences[0];
  }
};

const binary: SequenceTransform = (lines: Statement) => {
  let value = 0;
  for (let i = 0; i < lines.length; i += 1) {
    const k = lines.length - i - 1;
    // eslint-disable-next-line no-bitwise
    if (lines[k] === 7 || lines[k] === 9) value += 1 << i;
  }
  return value;
};

const transformed = (i: Identity, transform: SequenceTransform): number =>
  transform(hexagrams[i.number - 1].lines);

function compare(a: Identity, b: Identity, transform?: SequenceTransform) {
  const [A, B] = (transform && [
    transformed(a, transform),
    transformed(b, transform)
  ]) || [a.number, b.number];

  if (A > B) {
    return -1;
  }
  if (A < B) {
    return 1;
  }
  return 0;
}

const asc = (collection: Guà[], transform?: SequenceTransform) =>
  transform
    ? collection.sort(
        (a: Identity, b: Identity) => compare(a, b, transform) * -1
      )
    : collection.sort((a: Identity, b: Identity) => compare(a, b) * -1);

const desc = (collection: Guà[], transform?: SequenceTransform) =>
  transform
    ? collection.sort((a: Identity, b: Identity) => compare(a, b, transform))
    : collection.sort(compare);

export const sorted = (collection: Guà[], value?: string): Guà[] => {
  switch (value) {
    case sequences[3]:
      return desc(collection, binary);
    case sequences[2]:
      return asc(collection, binary);
    case sequences[1]:
      return desc(collection);
    case sequences[0]:
      return asc(collection);
    default:
      return collection;
  }
};

export default Sequence;
